import React, { useRef, useState } from "react";

import CategoryBreadCrumb from "./BreadCrumb/CategoryBreadCrumb";
import CategoryHeader from "./Header/CategoryHeader";
import CategoryList from "./CategoryList/CategoryList";

const CategoryBody = () => {
  const [downloadExcel, setDownloadExcel] = useState(false);
  const [reloadCategoryList, setreloadCategoryList] = useState(false);

  /* hook to search */
  const [search, setSearch] = useState("");
  /* hook to get number of records */
  const [records, setRecords] = useState(0);

  const blockRefSelected = useRef(null); // this will be used to acccess dom element directly
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);

  /* function for checking record count */
  const checkedRecordCount = (selectCount, ids = []) => {
    if (blockRefSelected.current) {
      blockRefSelected.current.innerHTML = selectCount;
    }
    setSelectedCategoryIds(ids);
  };

  return (
    <section className="mail-wrapper py-2">
      <div className="container-fluid px-4">
        <CategoryBreadCrumb />
        <CategoryHeader
          setSearch={setSearch}
          setDownloadExcel={setDownloadExcel}
          setreloadCategoryList={setreloadCategoryList}
          records={records}
          blockRefSelected={blockRefSelected}
          selectedCategoryIds={selectedCategoryIds}
        />
        <CategoryList
          search={search}
          downloadExcel={downloadExcel}
          reloadCategoryList={reloadCategoryList}
          setreloadCategoryList={setreloadCategoryList}
          setRecords={setRecords}
          checkedRecordCount={checkedRecordCount}
        />
      </div>
    </section>
  );
};

export default CategoryBody;
